export enum QuickShareStatusEnum {
  Pending = 'Pending',
  Uploading = 'Uploading',
  ConnectionError = 'ConnectionError',
  Error = 'Error',
  SomeErrors = 'SomeErrors',
  ShareError = 'ShareError',
  Completed = 'Completed',
}
